export const getStockFilter = state => state.stockReport.filter
